// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608202134/js/" + chunkId + "." + {"44":"cd5dcd62","225":"0a020b71","481":"7fec682a","486":"11942a7e","770":"3158020b"}[chunkId] + ".0.9674943771059762.chunk.js";
};